import React, { useRef, useEffect } from 'react';
import { graphql } from 'gatsby';

import { Layout } from 'soluble-gatsby-source';

import DocumentationMenu from '../components/DocumentationMenu';
import DocumentationApiSection from '../components/DocumentationApiSection';
import BreadcrumbSection from '../components/BreadcrumbSection';

let SCRIPT_ADDED = false;

export default function DocumentationApi({ data }) {
    const sectionRef = useRef();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            document.documentElement.classList.add('template-api');
            document.documentElement.style.fontSize = '16px';
        }
    }, []);

    useEffect(() => {
        if (
            typeof window === 'undefined' ||
            !data.docsApi.addWidgetScript ||
            !process.env.GATSBY_APLAZAME_WIDGET_SCRIPT_URL ||
            SCRIPT_ADDED
        ) {
            return;
        }

        const script = window.document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = `${process.env.GATSBY_APLAZAME_WIDGET_SCRIPT_URL}`;
        window.document.querySelector('head').appendChild(script);

        if (process.env.GATSBY_DEMO_SCRIPT_URL) {
            const scriptDemo = window.document.createElement('script');
            scriptDemo.src = `${process.env.GATSBY_DEMO_SCRIPT_URL}/widgets/demo.js`;
            window.document.querySelector('head').appendChild(scriptDemo);

            const configuratorCSS = window.document.createElement('link');
            configuratorCSS.type = 'text/css';
            configuratorCSS.rel = 'stylesheet';
            configuratorCSS.href = `${process.env.GATSBY_DEMO_SCRIPT_URL}/widgets/demo.js.css`;
            window.document.querySelector('head').appendChild(configuratorCSS);
        }

        SCRIPT_ADDED = true;
    }, [data.docsApi.addWidgetScript]);

    return (
        <Layout navbarFixed={true}>
            <DocumentationMenu
                activeDocApiId={data.docsApi.id}
                items={data.allDocsApiMenu.edges.map(({ node }) => node)}
                sectionRef={sectionRef}
            />
            <div ref={sectionRef}>
                <DocumentationApiSection content={data.docsApi.content} />
            </div>
            <BreadcrumbSection
                home={data.home}
                page={{
                    ...data.docsApi,
                    treeParent: data.pluginsPage.pluginsPage,
                }}
            />
        </Layout>
    );
}

export const query = graphql`
    query DocumentationApi(
        $language: String
        $contentLanguage: String
        $id: String
    ) {
        home: datoCmsPage(slug: { eq: "" }, locale: { eq: $language }) {
            id
            slug
            title
        }

        pluginsPage: datoCmsSetting {
            pluginsPage {
                slug
                title
                treeParent {
                    title
                    slug
                    treeParent {
                        title
                        slug
                    }
                }
            }
        }

        allDocsApiMenu(
            filter: { isRoot: { eq: true }, language: { eq: $contentLanguage } }
            sort: { fields: position, order: ASC }
        ) {
            edges {
                node {
                    slug
                    text
                    docApi {
                        id
                        slug
                    }
                    subitems {
                        slug
                        text
                        isPage
                        docApi {
                            id
                            slug
                        }
                        subitems {
                            slug
                            text
                            docApi {
                                id
                                slug
                            }
                        }
                    }
                }
            }
        }

        docsApi(id: { eq: $id }, language: { eq: $contentLanguage }) {
            id
            title
            slug
            content
            addWidgetScript
        }
    }
`;
